<div class="bg-gray-100 border-b border-gray-80 p-4 shadow-xs transition-shadow hover:shadow-md">
  <div class="flex justify-between items-start mb-2">
    <div class="flex items-center gap-2 flex-1">
      <h3 class="text-body-1-desktop font-semibold text-gray-10 m-0">{{ displayName() }}</h3>
      <lds-badge class="font-medium text-xs" [color]="statusBadgeColor()" [type]="BadgeType.FLAT" [size]="Size.SM">
        {{ statusLabel() }}
      </lds-badge>
    </div>
    <div class="flex gap-2 ml-2">
      <!--TODO: pass ARIA Label, after LDS fixes [aria-label]="'getDirections' | translate" -->
      <lds-button [iconOnly]="directionIcon" (click)="onDirectionsClick()" />
      <!--TODO: pass ARIA Label, after LDS fixes [aria-label]="'moreInformation' | translate" -->
      <lds-button [variant]="secondaryVariant" [iconOnly]="infoIcon" (click)="openDetails()" />
    </div>
  </div>

  @if (station().distance && station().travelTime) {
    <div class="text-body-2-desktop text-gray-60 mb-2">
      {{ station().travelTime }} {{ 'mins' | translate }} • {{ station().distance }} {{ 'km' | translate }}
    </div>
  }

  <div class="text-body-2-desktop text-gray-40 mb-3">
    {{ fullAddress() }}
  </div>

  <div class="flex flex-wrap gap-2">
    @for (service of visibleServices(); track service.name) {
      <span class="py-1 px-3 bg-gray-90 text-gray-40 rounded-full text-caption-desktop" [title]="service.displayName">
        {{ service.displayName }}
      </span>
    }
    @if (overflowCount() > 0) {
      <span class="py-1 px-3 bg-gray-80 text-gray-40 rounded-full text-caption-desktop font-medium"
        >+ {{ overflowCount() }}</span
      >
    }
  </div>
</div>
